module.exports = __webpack_public_path__ + "static/img/cocina_05.d3ad4327.jpeg";